export default {
  badge: 'Insignă',
  open: 'Open',
  close: 'Închideți',
  dismiss: 'Dismiss',
  confirmEdit: {
    ok: 'OK',
    cancel: 'Anulează',
  },
  dataIterator: {
    noResultsText: 'Nu s-au găsit înregistrări corespunzătoare',
    loadingText: 'Se încarcă articolele...',
  },
  dataTable: {
    itemsPerPageText: 'Rânduri pe pagină:',
    ariaLabel: {
      sortDescending: 'Sortate descendent.',
      sortAscending: 'Sortate ascendent.',
      sortNone: 'Nesortate.',
      activateNone: 'Activați pentru a elimina sortarea.',
      activateDescending: 'Activați pentru a sorta descendent.',
      activateAscending: 'Activați pentru a sorta ascendent.',
    },
    sortBy: 'Sortați după',
  },
  dataFooter: {
    itemsPerPageText: 'Articole pe pagină:',
    itemsPerPageAll: 'Toate',
    nextPage: 'Pagina următoare',
    prevPage: 'Pagina anterioară',
    firstPage: 'Prima pagină',
    lastPage: 'Ultima pagină',
    pageText: '{0}-{1} din {2}',
  },
  dateRangeInput: {
    divider: 'până la',
  },
  datePicker: {
    itemsSelected: '{0} selectate',
    range: {
      title: 'Selectați datele',
      header: 'Introduceți datele',
    },
    title: 'Selectați data',
    header: 'Introduceți data',
    input: {
      placeholder: 'Introduceți data',
    },
    ariaLabel: {
      previousMonth: 'Luna anterioară',
      nextMonth: 'Luna următoare',
      selectYear: 'Selectați anul',
      previousYear: 'Anul precedent',
      nextYear: 'Anul următor',
      selectMonth: 'Selectați luna',
      selectDate: '{0}',
      currentDate: 'Astăzi, {0}',
    },
  },
  noDataText: 'Nu există date disponibile',
  carousel: {
    prev: 'Vizualul anterior',
    next: 'Vizualul următor',
    ariaLabel: {
      delimiter: 'Slide carusel {0} din {1}',
    },
  },
  calendar: {
    moreEvents: 'încă {0}',
    today: 'Today',
  },
  input: {
    clear: 'Șterge {0}',
    prependAction: '{0} acțiune de inserare la început',
    appendAction: '{0} acțiune de inserare la sfârșit',
    otp: 'Introduceți caracterul OTP {0}',
  },
  fileInput: {
    counter: '{0} fișiere',
    counterSize: '{0} fișiere ({1} în total)',
  },
  fileUpload: {
    title: 'Trageți și plasați fișierele aici',
    divider: 'sau',
    browse: 'Răsfoiți fișiere',
  },
  timePicker: {
    am: 'AM',
    pm: 'PM',
    title: 'Selectați ora',
    hour: 'Oră',
    minute: 'Minute',
    second: 'Secunde',
  },
  pagination: {
    ariaLabel: {
      root: 'Navigare prin pagini',
      next: 'Pagina următoare',
      previous: 'Pagina anterioară',
      page: 'Mergeți la pagina {0}',
      currentPage: 'Pagina curentă, pagina {0}',
      first: 'Prima pagină',
      last: 'Ultima pagină',
    },
  },
  stepper: {
    next: 'Următor',
    prev: 'Înapoi',
  },
  rating: {
    ariaLabel: {
      item: 'Evaluare {0} din {1}',
    },
  },
  loading: 'Se încarcă...',
  infiniteScroll: {
    loadMore: 'Încarcă mai multe',
    empty: 'Nu mai există',
  },
  rules: {
    required: 'Acest câmp este obligatoriu',
    email: 'Vă rugăm să introduceți o adresă de email validă',
    number: 'Acest câmp poate conține doar numere',
    integer: 'Acest câmp poate conține doar valori întregi',
    capital: 'Acest câmp poate conține doar litere mari',
    maxLength: 'Trebuie să introduceți maximum {0} caractere',
    minLength: 'Trebuie să introduceți minimum {0} caractere',
    strictLength: 'Lungimea câmpului introdus este invalidă',
    exclude: 'Caracterele {0} nu sunt permise',
    notEmpty: 'Vă rugăm să alegeți cel puțin o valoare',
    pattern: 'Format invalid',
  },
  hotkey: {
    then: 'apoi',
    ctrl: 'Ctrl',
    command: 'Command',
    shift: 'Shift',
    alt: 'Alt',
    option: 'Option',
    enter: 'Enter',
    escape: 'Escape',
    upArrow: 'Săgeată sus',
    downArrow: 'Săgeată jos',
    leftArrow: 'Săgeată stânga',
    rightArrow: 'Săgeată dreapta',
    backspace: 'Backspace',
    space: 'Spațiu',
    plus: 'plus',
    shortcut: 'Comandă rapidă tastatură: {0}',
    or: 'sau',
  },
  video: {
    play: 'Redare',
    pause: 'Pauză',
    seek: 'Căutare',
    volume: 'Volum',
    showVolume: 'Afișare control volum',
    mute: 'Fără sunet',
    unmute: 'Cu sunet',
    enterFullscreen: 'Ecran complet',
    exitFullscreen: 'Ieșire din ecran complet',
  },
  colorPicker: {
    ariaLabel: {
      eyedropper: 'Alege culoarea de pe ecran',
      hueSlider: 'Nuanță',
      alphaSlider: 'Alfa',
      redInput: 'Roșu',
      greenInput: 'Verde',
      blueInput: 'Albastru',
      alphaInput: 'Alfa',
      hueInput: 'Nuanță',
      saturationInput: 'Saturație',
      lightnessInput: 'Luminozitate',
      hexInput: 'Valoare HEX',
      hexaInput: 'Valoare HEX cu alfa',
      changeFormat: 'Schimbă formatul culorii',
    },
  },
}
